import type { CreateQuoteRateResultsResponse } from '@/modules/spot-quote/data-provider/create-quote-rate-results/api';

export const normalizeCreateQuoteRateResults = (data: CreateQuoteRateResultsResponse) => {
  if (!data || !data.rateResults) {
    return [];
  }

  return data.rateResults;
};
